var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 23,
    viewBox: "0 0 80 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5H80",
    stroke: "#165EF3",
    strokeOpacity: 0.14,
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.664 0.5L21 3.085L29.6532 11.5L21 19.915L23.664 22.5L35 11.5L23.664 0.5Z",
    fill: "#165EF3",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.664 0.5L31 3.085L39.6532 11.5L31 19.915L33.664 22.5L45 11.5L33.664 0.5Z",
    fill: "#165EF3",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.664 0.5L41 3.085L49.6532 11.5L41 19.915L43.664 22.5L55 11.5L43.664 0.5Z",
    fill: "#165EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataActive);
export default __webpack_public_path__ + "static/media/icon_data_active.eb283236fe50a8ee1eb7e7d4bc96eab4.svg";
export { ForwardRef as ReactComponent };